export const titles = [
  {
    name:'分析报告',
    id:'1',
    code:'fxbg'
  },
  {
    name:'服务成果',
    id:'2',
    code:'fwal'
  }
  // ,
  // {
  //   name:'业务研究',
  //   id:'3',
  //   code:'ywyj'
  // }
]